import { render, staticRenderFns } from "./InfoDependentEHB.vue?vue&type=template&id=545df3f9&scoped=true"
import script from "./InfoDependentEHB.vue?vue&type=script&lang=js"
export * from "./InfoDependentEHB.vue?vue&type=script&lang=js"
import style0 from "./InfoDependentEHB.vue?vue&type=style&index=0&id=545df3f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545df3f9",
  null
  
)

export default component.exports